import React from 'react';
import {Styles} from "../../../../config/design/styles";
import { withStyles } from '@mui/styles';
import NotificationManagerPage from "./NotificationManagerPage";

function NotificationManagerPageWrapper(){
    return (
        <NotificationManagerPage/>
    );
}

export default withStyles(Styles)(NotificationManagerPageWrapper);
